import { getJrnDefaultComponent } from '../getJrn/getJrnDefaultComponent.js'
import getSiteController from './getSiteController.js'
import _module from 'module.js'
import _ from 'lodash'

let getSiteComponent = _.cloneDeep(getJrnDefaultComponent)
getSiteComponent.controller = getSiteController

_module.component('getSite', getSiteComponent)
